import { FaCameraRetro, FaLock } from 'react-icons/fa6';
import { FaShieldAlt } from 'react-icons/fa';
import images from './images';

const pricing = [
    {
        id: 1,
        image: images.plan1,
        icon: <FaShieldAlt />, // Shield icon for Basic Plan
        title: 'Basic Plan',
        content: 'For Small Properties',
        price: 29.99,
        features: [
            '2 CCTV Cameras',
            '24/7 Monitoring',
            'Basic Alarm System',
            'Mobile App Access',
            'Limited Warranty',
        ],
    },
    {
        id: 2,
        image: images.plan2,
        icon: <FaCameraRetro />, // Camera icon for Standard Plan
        title: 'Standard Plan',
        content: 'For Medium Properties',
        price: 49.99,
        features: [
            '4 CCTV Cameras',
            '24/7 Monitoring',
            'Advanced Alarm System',
            'Mobile App & Cloud Storage',
            'Extended Warranty',
        ],
    },
    {
        id: 3,
        image: images.plan3,
        icon: <FaLock />, // Lock icon for Premium Plan
        title: 'Premium Plan',
        content: 'For Large Properties',
        price: 79.99,
        features: [
            '8 Cameras Installed',
            'AI-Enhanced 24/7 Monitoring',
            'Advanced Alarm System',
            'App, Cloud & Reports',
            'Lifetime Coverage',
        ],
    },
];

export default pricing;